import { WHEN_BLOCK } from 'constants/MeshbotConstant';

/**
 * Builds the "user" field (dictionaryId) of an isUserLockOperation when-block.
 * optionItemValue points to the user_codes dictionary; it is omitted for the "invalid code" case (user = -1),
 * where there is no user_codes reference.
 * @param {Object} dynamicFields - { userFieldValue, userCodesItemId }
 * @returns {Object} the "user" field
 */
export const buildUserField = (dynamicFields) => {
    const userField = {
        name: WHEN_BLOCK.USER,
        type: WHEN_BLOCK.TYPE.DICTIONARY_ID,
        value: dynamicFields.userFieldValue,
    };

    if (dynamicFields.userCodesItemId) {
        userField.optionItemValue = { itemId: dynamicFields.userCodesItemId };
    }

    return userField;
};
